import GroupMeasureDescView from './GroupMeasureDescView';
import GroupMeasureDetailView from './GroupMeasureDetailView';
import NewGroupMeansureView from './NewGroupMeansureView';
import MeasureDescView from './MeasureDescView';
import SchemaDescView from './SchemaDescView';
import SchemaDetailView from './SchemaDetailView';

import { BrowserRouter as Router, Link, Route, Redirect } from 'react-router-dom';
import React from 'react';
import { Layout, Menu, Button } from 'antd';
import { MenuOutlined, UnorderedListOutlined, DatabaseOutlined } from '@ant-design/icons';
import { isNotEmpty } from '../Service/Utils';
//import { SubMenu } from 'react-contextmenu';

const { SubMenu } = Menu;
const { Content, Sider } = Layout;

// bcz_datap_strategy	863
// datap_bcz	454
// datap_finance	636
// datap_mintpie	352
// datap_nocturne	158
// datap_realtime	787

const projectNames = ['bcz_datap',
    'bcz_app_data',
    'bcz_datap_biz_platform',
    'bcz_datap_ecmall',
    'bcz_datap_mintpie',
    'bcz_datap_strategy',
    'datap_bcz',
    'datap_finance',
    'datap_mintpie',
    'datap_nocturne',
    'datap_realtime'
];

const projectsSpaces = [
    {
        name: 'MaxCompute',
        icon: '',
        chidren: [
            'bcz_datap',
            'bcz_app_data',
            'bcz_datap_biz_platform',
            'bcz_datap_ecmall',
            'bcz_datap_mintpie',
        ]
    }, {
        name: 'Hologres',
        icon: '',
        chidren: [
            'bcz_datap_strategy',
            'datap_bcz',
            'datap_finance',
            'datap_mintpie',
            'datap_nocturne',
            'datap_realtime'
        ]
    }
];

class DataMapView extends React.Component {

    pathToView = {
        '/data_map/old_measure_desc': 'OldMeasureDesc',
        '/data_map/group_measure_desc': 'GroupMeasureDesc',
        '/data_map/group_measure_desc/new': 'GroupMeasureDesc',
        '/data_map/schema_desc': 'SchemaDesc',
        '/data_map/schema_desc/projects/bcz_datap': 'SchemaDesc/bcz_datap',
        '/data_map/schema_desc/projects/bcz_app_data': 'SchemaDesc/bcz_app_data',
        '/data_map/schema_desc/projects/bcz_datap_biz_platform': 'SchemaDesc/bcz_datap_biz_platform',
        '/data_map/schema_desc/projects/bcz_datap_ecmall': 'SchemaDesc/bcz_datap_ecmall',
        '/data_map/schema_desc/projects/bcz_datap_mintpie': 'SchemaDesc/bcz_datap_mintpie',
        '/data_map/schema_desc/projects/bcz_datap_strategy': 'SchemaDesc/bcz_datap_strategy',
        '/data_map/schema_desc/projects/datap_bcz': 'SchemaDesc/datap_bcz',
        '/data_map/schema_desc/projects/datap_finance': 'SchemaDesc/datap_finance',
        '/data_map/schema_desc/projects/datap_mintpie': 'SchemaDesc/datap_mintpie',
        '/data_map/schema_desc/projects/datap_nocturne': 'SchemaDesc/datap_nocturne',
        '/data_map/schema_desc/projects/datap_realtime': 'SchemaDesc/datap_realtime',
    }

    constructor() {
        super();
        const path = window.location.pathname;
        let view = this.pathToView[path];
        if (isNotEmpty(view)) {

        } else {
            const p = /^\/data_map\/schema_desc\/detail\/(\w+)\/(\w+)$/;
            const m = path.match(p);
            if (m !== null) {
                view = `SchemaDesc/${m[1]}`;
            }
        }
        this.state = {
            collapsed: false,
            currentView: view === undefined ? 'SchemaDesc/bcz_datap' : view,
            clientHeight: document.body.clientHeight - 120
        };
    }

    componentDidMount() {
        window.onresize = () => {
            this.setState({ clientHeight: document.body.clientHeight - 120 });
        };
    }

    render() {
        return (
            <Router basename="/data_map">
                <Layout className="site-layout-background" style={{ padding: '24px 0px 0px 0px' }} hidden={this.props.hidden} >
                    <Sider
                        className="site-layout-background"
                        width={200}
                        theme={"light"}
                        collapsed={this.state.collapsed}
                        style={{
                            height: this.state.clientHeight,
                            overflowY: 'auto',
                        }}
                    >
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={[this.state.currentView]}
                            defaultOpenKeys={['MeasureDesc', 'SchemaDesc', 'MaxCompute', 'Hologres']}
                            selectedKeys={[this.state.currentView]}
                            onSelect={(item) => this.setState({ currentView: item.key })}
                            style={{ height: '100%' }}
                        >
                            <Button size="middle" icon={<MenuOutlined />} onClick={this.collapseSider.bind(this)}
                                style={{
                                    color: "#000000",
                                    border: "none",
                                    margin: "0px 0px 0px 15px"
                                }}
                            />
                            {/* "bcz_datap_mintpie", "bcz_datap_ecmall", "bcz_datap_yoozy", "bcz_app_data", "bcz_datap" */}
                            <SubMenu key="SchemaDesc" icon={<DatabaseOutlined />} title="数仓">
                                {projectsSpaces.map(space => <SubMenu key={space.name} title={space.name}>
                                    {space.chidren.map(name => <Menu.Item key={`SchemaDesc/${name}`}>
                                        <Link to={`/schema_desc/projects/${name}`}>
                                            <span style={{ fontSize: 12 }}>{name}</span>
                                        </Link>
                                    </Menu.Item>)}
                                </SubMenu>)}
                            </SubMenu>
                            <SubMenu key="MeasureDesc" icon={<UnorderedListOutlined />} title="指标管理">
                                {/* <Menu.Item key="OldMeasureDesc">
                                    <Link to="/old_measure_desc">项目组指标</Link>
                                </Menu.Item> */}
                                <Menu.Item key="GroupMeasureDesc">
                                    <Link to="/group_measure_desc">集团核心指标</Link>
                                </Menu.Item>
                            </SubMenu>
                            
                        </Menu>
                    </Sider>
                    <Content justify="space-around" align="middle" style={{ padding: '0 0 0 10px', overflowY: 'hidden' }}>
                        {/* <Route path="/old_measure_desc" exact component={MeasureDescView} /> */}
                        <Route path="/group_measure_desc" exact component={GroupMeasureDescView} />
                        <Route path="/group_measure_desc/new" exact component={NewGroupMeansureView} />
                        <Route path="/group_measure_desc/detail/:id" exact render={(history) => <GroupMeasureDetailView measureId={history.match.params.id} />} />
                        {projectNames.map(name =>
                            <Route
                                path={`/schema_desc/projects/${name}`}
                                exact
                                render={_ => <SchemaDescView projectName={name} />}
                            />)}
                        <Route path="/schema_desc/detail/:project/:name" render={(history) => <SchemaDetailView projectName={history.match.params.project} schemaName={history.match.params.name} />} />
                        <Route path="/" exact render={() => <Redirect to="/schema_desc/projects/bcz_datap" />} />
                    </Content>
                </Layout>
            </Router>
        );
    }
    // const clusteringId = history.match.params.id;
    collapseSider() {
        this.setState({ collapsed: !this.state.collapsed });
    }
}

export default DataMapView;